<div *ngFor="let question of groupedQuestions">
    <div #questionbody class="" *ngIf="!adminpaused && !proctorpaused" [attr.aria-label]="language.questionContent"
        [id]="'question-' + question.examQuestion.questionid" (click)="onQuestionClicked(question.examQuestion.questionno, question.examQuestion.questionid)">
        <div class="d-flex justify-content-center title-container">
            <h2 #questionTitle class="question-title" [title]="getQuestionTitle(question)"
                [attr.aria-label]="getQuestionTitle(question)" tabindex="0">
                {{getQuestionTitle(question)}}
            </h2>
        </div>
        <app-question class="w-100" *ngIf="question.questionCount" [isloadingdata]="isLoadingData"
            (quesunanswered)="questionUnanswered(question.examQuestion.questionno)" 
            (quesanswered)="questionAnswered(question.examQuestion.questionno)"
            [question]="question" (quesflagged)="flagclicked(question.examQuestion.questionno)" (nextclicked)="nextbtnclicked()"
            (previousclicked)="prevbtnclicked()" [question]=" question"
            [url]="url" [adminpaused]="adminpaused" [proctorpaused]="proctorpaused" [status]="status" [examid]="examid"
            [scheduleid]="scheduleid" [loadingSubject]="this.loadingSubject"
            [networkFailureSubject]="networkFailureSubject" [requiresScreenReader]="requiresScreenReader"
            [liteMode]="question.examination.liteMode">
        </app-question>
        <hr />
        <hr />
    </div>
</div>
